export default __webpack_public_path__ + "static/media/yt_icon.1776a109.svg";